"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var antd_1 = require("antd");
var Sider = antd_1.Layout.Sider;
exports.default = styled_components_1.default(Sider)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-right: 1px solid #dfdfdf;\n"], ["\n  border-right: 1px solid #dfdfdf;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map